module.exports = __webpack_public_path__ + "images/emoji/snowman.d91eb104f0f122b3e029.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/snowman.png
// module id = miww
// module chunks = 24